import type { ComponentSchema } from '../../../../../schema-types'
import { schema as base } from '../product/product-detail.schema'

/**
 * Nakshi product page: the base fields plus a size-guide drawer (merchant rich text), a fabric chip, saree
 * details and care notes, a WhatsApp order button, the "Complete the look" rail and the delivery areas table. All optional; empty values hide their piece.
 */
export const schema: ComponentSchema = {
  ...base,
  commonFields: [
    ...base.commonFields,
    { key: 'sizeGuideTitle', label: 'Size guide link and title', type: 'string', default: 'Size guide' },
    { key: 'sizeGuide', label: 'Size guide', type: 'rich-text', help: 'Measurements table or fit notes, opened from a link beside the size selector. Hidden while empty.' },
    { key: 'completeTheLookTitle', label: '"Complete the look" title', type: 'string', default: 'Complete the look', help: 'Other products from the same category, shown under the product.' },
    { key: 'showFabric', label: 'Show fabric chip', type: 'boolean', default: true, help: 'From the product Fabric attribute (Jamdani, Muslin, Katan, Cotton…).' },
    { key: 'sareeDetails', label: 'Saree details', type: 'rich-text', default: '<p>Length 5.5 m with a 0.8 m unstitched blouse piece.</p>', help: 'Shown under the description. Hidden while empty.' },
    { key: 'careNotes', label: 'Care notes', type: 'rich-text', default: '<p>Dry clean only. Store folded in muslin cloth, away from damp.</p>' },
    { key: 'whatsappOrderLabel', label: 'WhatsApp order button', type: 'localized-string', default: 'Order on WhatsApp', help: 'Uses the store WhatsApp number. Hidden when none is set.' },
    { key: 'showDeliveryAreas', label: 'Show delivery areas and charges', type: 'boolean', default: true },
  ],
}
